import { LoaderFunctionArgs, useLoaderData, useOutletContext } from "react-router";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ICONS_PREPEND, KEMONO_SITE, SITE_NAME } from "#env/env-vars";
import { fetchProfileDMs } from "#api/dms";
import { PageSkeleton } from "#components/pages";
import { CardList, DMCard } from "#components/cards";
import { paysites } from "#entities/paysites";
import { IApprovedDM } from "#entities/dms";
import { useEffect, useState } from "react";
import { OutletContext } from "./creator-page";

interface IProps {
  dms: (IApprovedDM & { contentFilter: string })[];
}

export function ProfileDMsPage() {
  const { dms } = useLoaderData() as IProps;
  const { creator } = useOutletContext() as OutletContext;
  const [filteredDms, setFilteredDms] = useState([...dms].sort((a, b) => b.published.valueOf() - a.published.valueOf()));
  const [filter, setFilter] = useState("");
  const paysite = paysites[creator.service];
  const title = `DMs of "${creator.name}" (${creator.id}) from ${paysite.title}`;

  useEffect(() => {
    setFilteredDms(
      [...(filter ? dms.filter(dm => dm.contentFilter.includes(filter.toLowerCase())) : dms)]
        .sort((a, b) => b.published.valueOf() - a.published.valueOf())
    );
  }, [dms, filter]);

  return (
    <PageSkeleton name="user" title={title}>
      <Helmet>
        <meta name="id" content={creator.id} />
        <meta name="service" content={creator.service} />
        <meta name="artist_name" content={creator.name} />
        {/* <link rel="canonical" href="{{ g.canonical_url }}" /> */}

        <meta property="og:title" content={title} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta
          property="og:image"
          content={`${ICONS_PREPEND ?? KEMONO_SITE}}/icons/${creator.service}/${creator.id}`}
        />
        {/* <meta property="og:url" content="{{ g.canonical_url }}" /> */}
      </Helmet>

      <div className="search-form" style={{maxWidth: "fit-content"}}>
        <input type="text" value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filter DMs" />
      </div>

      <CardList layout="phone">
        {filteredDms.length === 0 ? (
          <div className="no-results">
            <h2 className="site-section__subheading">
              Nobody here but us chickens!
            </h2>
            <p className="subtitle">There are no DMs for your query.</p>
          </div>
        ) : (
          filteredDms.map((dm) => <DMCard key={dm.hash} dm={dm} creator={creator} />)
        )}
      </CardList>
    </PageSkeleton>
  );
}

export async function loader({ params }: LoaderFunctionArgs): Promise<IProps> {
  const service = params.service!.trim();
  const creatorId = params.creatorId!.trim();

  const dms = await fetchProfileDMs(service, creatorId) as (IApprovedDM & { contentFilter: string })[];
  dms.forEach(dm => dm.contentFilter = dm.content.toLowerCase());

  return {
    dms: dms,
  };
}
